import { create } from 'apisauce';
import {BASE_URL} from 'api/urls';

const api = create({
    baseURL: BASE_URL,
    withCredentials: true,
});


export const getCarList = (data) => {
    return api.get('v1/cars/', data);
};

export const getCarDetail = (id) => {
    return api.get(`v1/cars/${id}`);
};

export default api;
